module.exports = __webpack_public_path__ + "banquet/components/ShoppingCartPopover/images/nav_bag_highlight.d51ddad3e765497ea6d29560a32c8cb6.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShoppingCartPopover/images/nav_bag_highlight.png
// module id = 1688
// module chunks = 1